import { buttonVariants } from "@/components/ui/button-variants";
import { cn } from "@/utils";

import { Button as ButtonPrimitive } from "@base-ui/react/button";
import { cloneElement, isValidElement } from "react";

function Button({
  className,
  variant = "default",
  size = "default",
  static: isStatic = false,
  render,
  nativeButton = true,
  children,
  ...props
}) {
  const buttonClassName = cn(
    buttonVariants({ variant, size, className }),
    !isStatic &&
      "transition-transform duration-150 ease-out active:not-disabled:scale-[0.96] motion-reduce:duration-100 motion-reduce:active:not-disabled:scale-[0.995]"
  );

  if (!nativeButton && isValidElement(render)) {
    return cloneElement(
      render,
      {
        ...props,
        ...render.props,
        "data-slot": "button",
        "data-variant": variant,
        "data-size": size,
        className: cn(buttonClassName, render.props.className),
      },
      children
    );
  }

  return (
    <ButtonPrimitive
      data-slot="button"
      data-variant={variant}
      data-size={size}
      className={buttonClassName}
      render={render}
      nativeButton={nativeButton}
      {...props}
    >
      {children}
    </ButtonPrimitive>
  );
}

export { Button };
